import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  getAssetAssignDetails,
  getAssetAudits,
  releaseAsset,
} from "../../api/asset";
import { handleAxiosError } from "../../config/action-config";
import { assetAssignedTable as tableDef } from "../../config/grid-columns-defs";
import BetterControlledTable from "../../component/BetterControlledTable";
import { useParams } from "react-router-dom";
import { showAlert } from "../../actions/alert";
import { useNavigate } from "react-router-dom";

export default function AssignAsset({ status }) {
  console.log("status", status);
  const params = useParams();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [auditTableRefreshCount, setAuditTableRefreshCount] = useState(0);

  async function getAseetAssignTableData(limit, offset) {
    try {
      const { data } = await getAssetAssignDetails(
        params.id,
        { limit, offset },
        user.token
      );
      return {
        rows: data.assetdetails,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    }
  }

  async function handleReleaseAsset(assetId, assignedEmpId) {
    const combineData = { asset_id: assetId, assigned_emp_id: assignedEmpId };
    try {
      const { data } = await releaseAsset(combineData, user.token);
      dispatch(showAlert(data.msg));
      refreshTable();
      navigate("/asset");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  function refreshTable() {
    setAuditTableRefreshCount((prev) => prev + 1);
  }

  return (
    <Box className="pmt-container-box">
      <div className="pmt-controll-table ">
        <BetterControlledTable
          getTableRows={getAseetAssignTableData}
          columns={[
            {
              headerName: "Action",
              field: "releaseAsset",
              cellRendererFramework: ({ data }) => (
                <>
                  {(data?.released_by === null || data?.released_by === "") && (
                    <Button
                      sx={{ height: "30px", py: 1 }}
                      className="blue-button"
                      onClick={() => {
                        handleReleaseAsset(data.asset_id, data.assigned_emp_id);
                      }}
                    >
                      Release
                    </Button>
                  )}
                </>
              ),
            },
            ...tableDef,
          ]}
          perPage={20}
          refreshCounter={auditTableRefreshCount}
        />
      </div>
    </Box>
  );
}
